import React from "react";
class Progress extends React.Component
{
    constructor(props)
    {
        super(props);
        this.animationProgress = 0;
    }
    animationGoesOn ()
    {
        const precent = Math.ceil( this.props.usage/ this.props.quota*100);
        if(this.animationProgress <  precent)
        {
            this.updateProgress();
            setTimeout(
                this.forceUpdate.bind(this),
                2/ (precent/100)
            )
        }
    }
    updateProgress()
    {
        this.animationProgress++;
    }

    fullColorHex = function(r,g,b) {
        let red = this.rgbToHex(r);
        let green = this.rgbToHex(g);
        let blue = this.rgbToHex(b);
        return red+green+blue;
    };

    rgbToHex (rgb) {
        let hex = Number(rgb).toString(16);
        if (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };

    render() {
        const animProgress = this.animationProgress;
        let percent = this.animationProgress;
        let progress = Math.min(animProgress *2, 200);
        let empty = Number (100- animProgress)*2;
        const red = 210; //Math.round( 255* quotient);
        const green = Math.round( 255*(1-animProgress/100));
        let background = '#'+this.fullColorHex(red,green,0)
        this.animationGoesOn();
        return(
           <div style={{position:'relative', margin:'6px 0', height:'32px'}}>
               <div style={{width:progress, backgroundColor:background}} className="progress-filled">
               </div>
               <div style={{width:empty}} className="progress-empty">
               </div>
               <div style={{position:'absolute', left: progress, marginLeft: '6px', lineHeight: '28px'}}>{percent + '%'}</div>
            </div>
        );
    }
}
export default Progress


// WEBPACK FOOTER //
// ./src/components/EditSite/Progress.js